module.exports = __webpack_public_path__ + "img/horizontal_4_6_8004.cc01d46f.png";